import Alpine from "alpinejs";

window.Alpine = Alpine;

Alpine.data("videoPlay", () => ({
    play: false,
    init() {
        this.$watch("play", (value) => {
            if (value) {
                this.$refs.video.play();
            } else {
                this.$refs.video.pause();
            }
        });
    },
}));
